import type { CartItem, CartSubItem } from 'restful/tickets';

export const isCartItemOutOfStock = (item: CartItem | CartSubItem) =>
  'state' in item &&
  (item.state === 'OutOfStock' || item.state === 'Unavailable');
